"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = _interopRequireDefault(require("../checkbox/Checkbox"));

var TreeSelectAll = function TreeSelectAll(props) {
  var isDisabled = props.isDisabled,
      isChecked = props.isChecked,
      isEnabled = props.isEnabled,
      isIndeterminate = props.isIndeterminate,
      onSelect = props.onSelect;

  var handleSelectAll = function handleSelectAll(event) {
    return onSelect(event.target.checked, isIndeterminate);
  };

  return isEnabled ? /*#__PURE__*/_react.default.createElement("div", {
    className: 'TreeSelectAll display-flex align-items-center'
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    checked: isChecked,
    onClick: handleSelectAll,
    disabled: isDisabled,
    indeterminate: isIndeterminate
  })) : null;
};

TreeSelectAll.displayName = 'TreeSelectAll';
TreeSelectAll.defaultProps = {
  isChecked: false,
  isEnabled: true,
  isIndeterminate: false,
  hasSearchResults: false,
  onChange: function onChange() {}
};
TreeSelectAll.propTypes = {
  value: _propTypes.default.string,
  onSelect: _propTypes.default.func,
  isChecked: _propTypes.default.bool,
  isEnabled: _propTypes.default.bool,
  isDisabled: _propTypes.default.bool,
  isIndeterminate: _propTypes.default.bool,
  hasSearchResults: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = TreeSelectAll;
exports.default = _default;